import nxModule from 'nxModule';
import ParameterizedLocalCache from 'shared/utils/parameterized-local-cache';

nxModule.factory('fileCache', (http, CacheFactory, config) =>
  new ParameterizedLocalCache({
    provider: (fileId) => http.get(`/files/${fileId}`, {responseType: 'blob'}),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.fileCache,
    cacheName: 'fileCache'
  })
);
